import { jsxs as _jsxs } from "react/jsx-runtime";
export const ChartTooltip = ({ value, unit, isVisible })=>{
    if (!isVisible) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-100 transition-opacity duration-200 whitespace-nowrap z-10",
        children: [
            value.toLocaleString(),
            " ",
            unit
        ]
    });
};
